import { FC, useState } from 'react';
import cx from 'classnames/bind';
import { motion, AnimatePresence } from 'framer-motion';

import { Layout } from '@/components/Layout';
import { Button } from '@/components/Button';
import { Notification } from '@/components/Notification';
import Completion from '@/assets/completion.png';

import styles from './CompletionGame.module.scss';

interface CompletionGameProps {
  allPoints: number;
  isShowPoints: boolean;
  setStep: (value: number) => void;
}

const cn = cx.bind(styles);

const CompletionGame: FC<CompletionGameProps> = ({
  allPoints,
  isShowPoints,
  setStep,
}) => {
  const [isShowAnswer, setIsShowAnswer] = useState(true);

  const endGame = () => {
    setStep(9);
  };

  const MotionNotification = motion(Notification);

  return (
    <Layout className={cn('container')}>
      {isShowPoints && allPoints && isShowAnswer ? (
        <AnimatePresence>
          <MotionNotification
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 20, opacity: 0 }}
            transition={{ duration: 2, delay: 0.3, ease: 'backInOut' }}
            onAnimationComplete={() => {
              setIsShowAnswer(false);
            }}
            className={cn('points')}
            points={allPoints}
          />
        </AnimatePresence>
      ) : null}
      <div className={cn('wrapper')}>
        <img
          src={Completion}
          className={cn('img')}
          alt="Диалог между клиентом и сотрудником"
        />
        <div className={cn('content')}>
          <h1 className={cn('title')}>Информирование выполнено!</h1>
          <p className={cn('description')}>
            Следите за товаром месяца, чтобы получить новое вознаграждение. А
            для отработки навыков информирования, можно пройти сценарии еще раз
            без начисления баллов.
          </p>
          <Button handleClick={endGame}>Завершить</Button>
        </div>
      </div>
    </Layout>
  );
};

export default CompletionGame;
